import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  LinearProgress,
  List,
  Typography,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PdfPlus from '@material-ui/icons/AddBoxOutlined';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import PdfMinus from '@material-ui/icons/IndeterminateCheckBoxOutlined';
import ListIcon from '@material-ui/icons/List';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState, useRef } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { AppContext } from '../../AppContext';
import blueSkyVueLogo from '../../assets/images/bluesky-vue-logo.png';
import { checkIfAusumOrLc360, checkOrderRecommendationsRequirement } from '../../enums/formHeaders';
import {
  completeOrderReview,
  createOrderPDFReport,
  getData,
  getHazardHubData,
  getVexcelPropertyData,
  getOrderableFormHeaders,
  getOrderById,
  getOrderRecommendations,
  getrecommendationCategorys,
  getRecommendationLibrarys,
  getRecommendationTypes,
  getValuationHistory,
  isUserAuthorizedToViewClient,
  PostRCTOrder,
  getRemoteInvisionData,
} from '../../services';
import { ActionBar } from './ActionBar';
import Content from './Content';
import ListItemFormHeaders from './ListItemFormHeaders';
import Navbar from './Navbar';
import OrderInfoFormDefinitions from './OrderInfoFormDefinitions';
import { OrderReviewProvider } from './OrderReviewContext';
import FORM_HEADERS from './../../enums/formHeaders';
import { isStupidICatOrCIGOrder } from '../../helpers';
import RemoveOrderFormHeaderDialog from '../RemoveOrderFormHeaderDialog';
import roles from '../../helpers/roles';
import WarningIcon from '@material-ui/icons/Warning';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const propTypes = {
  history: PropTypes.object.isRequired,
};

const drawerWidth = 325;

const styles = theme => ({
  root: {
    width: '100%',
    position: 'fixed',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  reviewHeader: {
    marginLeft: drawerWidth,
  },
  drawer: {
    width: drawerWidth,
  },
  drawerOpen: {
    marginLeft: drawerWidth,
  },
  contentWrapper: {
    padding: '12px',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    maxHeight: 'calc(100vh - 95px)',
  },
  loadingWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '100vh',
  },
  progressWrapper: {
    margin: '0 auto',
    textAlign: 'center',
  },
  progressTitle: {
    marginBottom: 24,
  },
  sideNavWrapper: {
    zIndex: 1,
    borderRadius: 0,
    background: 'var(--jmi-blue)',
    boxShadow: 'none',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    flexGrow: 1,
    maxHeight: 'calc(100vh - 71px)',
    overflowY: 'auto',
  },
  sideNavList: {
    width: '100%',
    maxWidth: 360,
    marginTop: 0,
    '& svg': {
      fill: '#7790b3',
    },
    '& ul': {
      marginTop: 0,
    },
  },
  completeButton: {
    color: '#fff',
    backgroundColor: '#71BF47',
    '&:hover': {
      background: '#4f8a30',
    },
  },
  completeButtonFocused: {
    backgroundColor: '#4f8a30',
  },
  orderInfo: {
    backgroundColor: '#315382',
  },
  orderInfoTitle: {
    color: '#fff',
    lineHeight: 'normal',
    display: 'inline-block',
    textTransform: 'capitalize',
    fontWeight: '300',
    margin: '0',
  },
  pdfPreview: {
    marginTop: '2rem',
    padding: '1rem',
    paddingBottom: '105px',
    maxWidth: '1000px',
    margin: '0 auto',
  },
  dialogTitle: {
    backgroundColor: '#fafafa',
    borderBottom: '1px solid #e1e1e1',
  },
  dialogActions: {
    backgroundColor: '#fafafa',
    borderBottom: '1px solid #e1e1e1',
  },
  toolbar: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  tooltip: {
    fontSize: '1rem',
  },
  pdfDialog: {
    '& div:nth-child(2)': {
      display: 'flex',
    },
  },
  doNotAdjustDueDate: {
    marginLeft: '1rem',
  },
});

const QaOrderReview = ({ classes, history, match }) => {
  const { orderLineId } = match.params;
  const {
    state: { sidebarIsOpen, roles: userRoles, canProcessCancel },
    dispatch,
  } = useContext(AppContext);

  const roleAssignments = {
    isAdmin: userRoles.includes(roles.ADMIN) || userRoles.includes(roles.SUPER_ADMIN),
    isQA: userRoles.includes(roles.QA),
    isUnderwriter: userRoles.includes(roles.UNDERWRITER),
    isClient: userRoles.includes(roles.CLIENT),
    isFieldRep: userRoles.includes(roles.FIELD_REP),
    isCallCenter: userRoles.includes(roles.CALLCENTER),
  };

  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState(null);
  const [orderInfo, setOrderInfo] = useState(null);
  const [formHeaders, setFormHeaders] = useState([]);
  const [cancelledOrder, setCancelledOrder] = useState(null);
  const [isCustomerCloseOutForm, setIsCustomerCloseOutForm] = useState(false);
  const [isValuationComplete, setIsValuationComplete] = useState(false);
  const [isValuationOverride, setIsValuationOverride] = useState(false);
  const [hazardHubData, setHazardHubData] = useState(null);
  const [vexcelPropertyData, setVexcelPropertyData] = useState(null);
  const [remoteInvisionData, setRemoteInvisionData] = useState(null);
  const [orderRecommendationData, setOrderRecommendationData] = useState(null);
  const [valuationHistory, setValuationHistory] = useState(null);
  const [isAusumOrLc360, setIsAusumOrLc360] = useState(false);
  const [ausumOrLc360Links, setAusumOrLc360Links] = useState(null);
  const [photoUploadDialogVisible, setPhotoUploadDialogVisible] = useState(false);
  const [isAllPhotosTab, setIsAllPhotosTab] = useState(false);
  const [RejectRestricted, setRejectRestricted] = useState(false);

  const toggleSidebar = open => {
    dispatch({
      type: 'SET_SIDEBAR_IS_OPEN',
      sidebarIsOpen: open,
    });
  };

  const clientAuthCheck = async clientId => {
    if (roleAssignments.isClient || roleAssignments.isUnderwriter) {
      try {
        const authorized = await isUserAuthorizedToViewClient(clientId);
        if (!authorized) {
          history.push('/unauthorized');
        }
      } catch (error) {
        console.log(error);
        history.push('/unauthorized');
      }
    }
  };

  const checkForValuation = order => {
    const replacementCostServiceTypeId = 13;
    const completeServiceStatusId = 7;
    const hasValuation = order.orderlineService.some(ols => ols.serviceTypeId === replacementCostServiceTypeId);

    return hasValuation
      ? order.orderlineService.some(
          ols => ols.serviceTypeId === replacementCostServiceTypeId && ols.serviceStatusId === completeServiceStatusId,
        )
      : true;
  };

  // this lets us add form headers (that aren't actually form headers) to the sidebar so that they become their own tab
  const customizeFormHeaders = (
    existingFormHeaders,
    { isCancelled, includeHazardHub, includeVexcelData,includeOrderRecommendations, includeValuationHistory, includeRemoteInvision },
  ) => {
    //console.log({existingFormHeaders})
    let newFormHeaders = existingFormHeaders.slice().sort((a, b) => {
      /**
       * Sort by:
       * 1. `seq` (ascending)
       * 2. `formHeaderId` (ascending)
       * 3. `orderFormHeaderId` (ascending)
       */

      if (a.seq !== b.seq) {
        return a.seq - b.seq;
      }

      if (a.formHeaderId !== b.formHeaderId) {
        return a.formHeaderId < b.formHeaderId ? -1 : 1;
      }

      if (a.orderFormHeaderId !== b.orderFormHeaderId) {
        return a.orderFormHeaderId < b.orderFormHeaderId ? -1 : 1;
      }

      return 0;
    });
    
    if (
      existingFormHeaders
        .filter(fh => fh.images)
        .map(fh => fh.images)
        .flat().length > 0
    ) {
      newFormHeaders.push({
        formHeaderId: 'all-photos-tab',
        orderFormHeaderId: 'all-photos-tab',
        name: 'All Photos',
        formHeader: {},
      });
    }

    if (includeHazardHub && !roleAssignments.isFieldRep) {
      newFormHeaders.push({
        formHeaderId: 'hazard-hub-tab',
        orderFormHeaderId: 'hazard-hub-tab',
        name: 'HazardHub Data',
        formHeader: {},
      });
    }

    if (includeVexcelData && !roleAssignments.isFieldRep) {
      newFormHeaders.push({
        formHeaderId: 'vexcel-property-tab',
        orderFormHeaderId: 'vexcel-property-tab',
        name: 'Vexcel Property Data',
        formHeader: {},
      });
    }
    if (includeRemoteInvision) {
      newFormHeaders.push({
        formHeaderId: 'remote-invision-tab',
        orderFormHeaderId: 'remote-invision-tab',
        name: 'Remote Worker Information',
        formHeader: {},
      });
    }

    if (includeOrderRecommendations && !roleAssignments.isFieldRep) {
      newFormHeaders.push({
        formHeaderId: 'order-recommendations-tab',
        orderFormHeaderId: 'order-recommendations-tab',
        name: 'Order Recommendations',
        formHeader: {},
      });
    }

    if (includeValuationHistory) {
      newFormHeaders.push({
        formHeaderId: 'valuation-history-tab',
        orderFormHeaderId: 'valuation-history-tab',
        name: 'Valuation History',
        formHeader: {},
      });
    }

    if (isCancelled) {
      newFormHeaders.push({
        formHeaderId: 'cancelled-tab',
        orderFormHeaderId: 'cancelled-tab',
        name: 'Cancellation',
        formHeader: {},
      });
    }

    if (roleAssignments.isFieldRep) {
      newFormHeaders = newFormHeaders.filter(
        fh =>
          ![
            //
            FORM_HEADERS.SKETCH,
          ].includes(fh.formHeaderId),
      );
    }

    // Underwriting action is NOT filtered out here for non-admins: its images must stay in state so they
    // still load in All Photos / photo tagging. It is hidden from the sidebar and next/previous navigation
    // instead (see isFormHeaderHidden in OrderReviewContext).

    setFormHeaders(newFormHeaders);
  };

  const getHazardHubDataAsync = async () => {
    try {
      const hazardHubData = await getHazardHubData(orderLineId);
      setHazardHubData(hazardHubData);
      return !!hazardHubData;
    } catch (error) {
      setHazardHubData(null);
    }
    return null;
  };

  const getVexcelPropertyDataAsync = async () => {
    try {
      const vexcelPropertyData = await getVexcelPropertyData(orderLineId);
      setVexcelPropertyData(vexcelPropertyData);
      return !!vexcelPropertyData;
    } catch (error) {
      setVexcelPropertyData(null);
    }
    return null;
  };
 // console.log({formHeaders})

  const getRemoteInvisionDataAsync = async () => {
    try {
      const remoteInvisionData = await getRemoteInvisionData(orderLineId);
      setRemoteInvisionData(remoteInvisionData);
      return !!remoteInvisionData;
    } catch (error) {
      setRemoteInvisionData(null);
    }
    return null;
  };

  const getOrderRecommendationDataAsync = async () => {
    try {
      const activeRecommendationsPromise = getOrderRecommendations(orderLineId);
      const recommendationLibrariesPromise = getRecommendationLibrarys();
      const recommendationTypesPromise = getRecommendationTypes();
      const recommendationCategoriesPromise = getrecommendationCategorys();

      const [
        activeRecommendations,
        recommendationLibraries,
        recommendationTypes,
        recommendationCategories,
      ] = await Promise.all([
        activeRecommendationsPromise,
        recommendationLibrariesPromise,
        recommendationTypesPromise,
        recommendationCategoriesPromise,
      ]);

      const recommendationData = {
        activeRecommendations,
        recommendationLibraries,
        recommendationTypes,
        recommendationCategories,
      };

      setOrderRecommendationData(recommendationData);
    } catch (error) {
      setOrderRecommendationData(null);
    }
  };

  const getValuationHistoryAsync = async () => {
    try {
      const response = await getValuationHistory(orderLineId);
      setValuationHistory(response);
    } catch (error) {
      setValuationHistory(null);
    }
  };

  const getOrderInfo = async () => {
    const order = await getOrderById(orderLineId);

    setOrderInfo(order);
    // console.log({order})
    return order;
  };

  useEffect(() => {
    const getDataAsync = async () => {
      try {
        let isCancelled = false;

        // get order details
        let order;
        let insuredPhone = null;
        let policyNumber = null;
        try {
          order = await getOrderInfo();
        } catch (err) {
          if (err && err.status === 401) {
            history.push('/unauthorized');
            return;
          }
          throw err;
        }

        if (order.policy.policyHolder.policyHolderPhone.length > 0) {
          insuredPhone = order.policy.policyHolder.policyHolderPhone[0].value;
        }
        if (order.policy.policyNumber) {
          policyNumber = order.policy.policyNumber;
        }

        // get data (service status, form headers, orderInfoFormDefinitions)
        let data;
        try {
          data = await getData(orderLineId, { insuredPhone, policyNumber });
          console.log({data})
        } catch (err) {
          console.log({err})
          if (err && err.status === 401) {
            history.push('/unauthorized');
            return;
          }
          throw err;
        }
        console.log({initformheader: data.formHeaders})
        clientAuthCheck(data.clientId);
        setClientId(data.clientId);
        setRejectRestricted(data.rejectRestricted)

        const orderableFormHeaders = await getOrderableFormHeaders(orderLineId);
        setOrderableFormHeaders(orderableFormHeaders || []);

        const isCommercial = checkOrderRecommendationsRequirement(data.formHeaders);
        const isAusumOrLc360 = checkIfAusumOrLc360(data.formHeaders);

        setIsAusumOrLc360(isAusumOrLc360);

        // returns true or false (if any data exists)
        const hazardHubDataExists = await getHazardHubDataAsync();
        const vexcelPropertyDataExists = await getVexcelPropertyDataAsync();
        const remoteInvisionDataExists = await getRemoteInvisionDataAsync()
        await getValuationHistoryAsync();
        await getOrderRecommendationDataAsync();
        setIsLoading(false);

        // if cancelled, filter out form headers that do not have images
        if (order.orderStateId === 4) {
          if (isAusumOrLc360) {
            // find all ausum links to show on cancel report
            const ausumOrLc360Links = data.formHeaders
              .map(fh => fh.formDefinitions)
              .flat()
              .filter(fd => fd.answerType === 'Hyperlink');

            setAusumOrLc360Links(ausumOrLc360Links);
          }

          data.formHeaders = data.formHeaders
            .filter(
              fh =>
                (fh.images && fh.images.length) ||
                fh.formHeaderId === FORM_HEADERS.NOTES_TO_QA ||
                fh.name.includes("Unable to Work") ||
                fh.name.toUpperCase().includes('PRIMARY') ||
                (canProcessCancel && fh.canEditOnCancel),
            )
            .sort((a, b) => (a.seq > b.seq ? 1 : -1));
            const ord = data.formHeaders.find(x=>x.name.includes("Unable to Work"))
            
          setCancelledOrder(order);
          setIsCustomerCloseOutForm(!!ord)
          isCancelled = true;
        }

        // set initial state for valuation if a valuation exists
        const valuationComplete = checkForValuation(order);
        setIsValuationComplete(valuationComplete);
        setIsValuationOverride(valuationComplete);
        setOrderInfo(order);
        setData(data);
        // console.log('data', data);

        const includeValuationHistory = data.formHeaders.some(fh =>
          [
            FORM_HEADERS.E2V_LEVEL_1,
            FORM_HEADERS.E2V_LEVEL_1_OTHER_STRUCTURES_REPLACEMENT_COST,
            FORM_HEADERS.CORE_LOGIC_LEVEL_1,
            FORM_HEADERS.QUICKVUE,
            FORM_HEADERS.ISO_360_LEVEL_1,
            FORM_HEADERS.MOBILE_HOME,
            FORM_HEADERS.MOBILE_HOME1,
          ].includes(fh.formHeaderId),
        );
        
        customizeFormHeaders(data.formHeaders, {
          isCancelled,
          includeHazardHub: hazardHubDataExists,
          includeVexcelData: vexcelPropertyDataExists,
          includeOrderRecommendations: isCommercial,
          includeValuationHistory,
          includeRemoteInvision: remoteInvisionDataExists
        });
      } catch (error) {
        console.log('error setting up order review screen...', error);
      }
    };
    getDataAsync();
  }, []);

  const isHighConfidencePhotos = data?.formHeaders.some(fh => fh.images.some(image => image.confidenceScore >= 61 && image.confidenceScore <= 100))

  window.onpopstate = evt => {
    toggleSidebar(true);
  };

  const [isCompleteDialogOpen, setIsCompleteDialogOpen] = useState(false);
  const [isRCTCompleteDialogOpen, setIsRCTCompleteDialogOpen] = useState(false);
  const [isReportSubmitting, setIsReportSubmitting] = useState(false);
  const getDrawerOpenState = () => {
    const value = localStorage.getItem('drawerOpen');
    if (value === 'false') {
      return false;
    } else {
      return true;
    }
  };
  const [drawerOpen, setDrawerOpen] = useState(getDrawerOpenState);
  const [pdfPreviewLink, setPdfPreviewLink] = useState(null);
  const [clientId, setClientId] = useState(null);
  const [orderableFormHeaders, setOrderableFormHeaders] = useState(null);
  const [numPages, setNumPages] = useState([1]);
  const [pdfScale, setPdfScale] = useState(1.0);
  const [sideViewForm, setSideViewForm] = useState(true);
  const [hideAllPhotos, setHideAllPhotos] = useState(false);
  const [taggedPhotos, setTaggedPhotos] = useState(false);

  const onDocumentLoadSuccess = ({ numPages }) => {
    var pageArray = [];
    for (var i = 1; i <= numPages; i++) {
      pageArray.push(i);
    }
    setNumPages(pageArray);
  };
  const DecreasePDFScale = ({ numPages }) => {
    var newscale = pdfScale - 0.25;
    if (newscale >= 0.25) {
      setPdfScale(newscale);
    }
  };
  const IncreasePDFScale = ({ numPages }) => {
    var newscale = pdfScale + 0.25;
    if (newscale <= 3) {
      setPdfScale(newscale);
    }
  };

  const submitReport = () => {
    setIsReportSubmitting(true);
    createOrderPDFReport(orderLineId, isValuationOverride)
      .then(data => {
        // debugger;
        completeOrderReviewAsync();
      })
      .catch(error => console.log(error));
  };

  const completeOrderReviewAsync = () => {
    completeOrderReview(orderLineId, cancelledOrder)
      .then(data => {
        if (data) {
          setIsCompleteDialogOpen(false);
          showSnackbar('Report submitted successfully!', 'success');
          toggleSidebar(true);
          history.push('/orders/qa');
        } else {
          showSnackbar('An error occurred during submission. Please wait a minute and try again.', 'error');
        }
        setIsReportSubmitting(false);
      })
      .catch(error => {
        // debugger;
        console.log('Error response:', error);
      
        // Try to extract errors array from the response
        const errors = error?.errors;
      
        if (Array.isArray(errors) && errors.length > 0) {
          const errorCount = errors.length;
      
          // Show only the first 10 errors in the snackbar
          const displayedErrors = errors.slice(0, 20).map(err => `${err.formHeader}: ${err.error}`).join('\n');
      
          // If more than 10 errors, add ellipsis
          const errorMessage = errorCount > 20 
      ? `${displayedErrors}\n...and ${errorCount - 20} more errors. \nClick to copy.`
      : displayedErrors;
      
          showSnackbar(errorMessage, 'error');

          if (errorCount > 20) {
            document.addEventListener('click', () => copyToClipboard(errors), { once: true });
          }
          //, () => copyToClipboard(errors)
        
        } else {
          // Default fallback message
          showSnackbar(error?.Message ?? error?.message ?? 'A submission error has occurred', 'error');
        }
      
        setIsReportSubmitting(false);
      });
      
      // .catch(error => {
      //   console.log(error);
      //   setIsReportSubmitting(false);
      //   showSnackbar(error?.Message ?? 'A Submission error has occured', 'error');
      // });
  };

  const submitRCTReport = async () => {
    try {
      const result = await PostRCTOrder(orderLineId, clientId);
      returnToGrid();
    } catch (e) {
      showSnackbar('Failed to Submit to RCT.', 'error');
    }
  };

  const copyToClipboard = (errors) => {
    const fullErrorMessage = errors.map(err => `${err.formHeader}: ${err.error}`).join('\n');
    
    navigator.clipboard.writeText(fullErrorMessage).then(() => {
      showSnackbar('Errors copied to clipboard!', 'success');
    }).catch(() => {
      showSnackbar('Failed to copy errors.', 'error');
    });
  };
  

  const handleCompleteDialogClose = () => {
    setIsCompleteDialogOpen(false);
  };

  const handleRCTCompleteDialogClose = () => {
    setIsRCTCompleteDialogOpen(false);
  };

  const showSnackbar = (message, variant) => {
    // debugger;
    dispatch({
      type: 'SET_SNACKBAR',
      snackbar: { isOpen: true, message: message, variant: variant },
    });
  };

  const returnToGrid = () => {
    toggleSidebar(true);

    (roleAssignments.isFieldRep || roleAssignments.isCallCenter) ? history.push('/') : history.push('/orders/qa');
  };


  return isLoading ? (
    <div className={classes.loadingWrapper}>
      <div className={classes.progressWrapper}>
        <Typography className={classes.progressTitle} variant="h4" color="primary">
          Preparing Order...
        </Typography>
        <LinearProgress />
      </div>
    </div>
  ) : (
    data && orderInfo && orderableFormHeaders && formHeaders.length && (
      <OrderReviewProvider
        data={data}
        order={orderInfo}
        getOrderInfo={getOrderInfo}
        formHeaders={formHeaders}
        hazardHubData={hazardHubData}
        vexcelPropertyData={vexcelPropertyData}
        remoteInvisionData={remoteInvisionData}
        orderRecommendationData={orderRecommendationData}
        valuationHistory={valuationHistory}
        isCancelled={!!cancelledOrder}
        isValuationComplete={isValuationComplete}
        isValuationOverride={isValuationOverride}
        setIsValuationOverride={setIsValuationOverride}
        setIsValuationComplete={setIsValuationComplete}
        isAusumOrLc360={isAusumOrLc360}
        ausumOrLc360Links={ausumOrLc360Links}
        roleAssignments={roleAssignments}
        orderableFormHeaders={orderableFormHeaders}
      >
        <div className="app">
          <div className={classnames('app-sidebar', !sidebarIsOpen && 'app-sidebar-closed')}>
            <div className="sidebar-logo-container">
              <img src={blueSkyVueLogo} className="sidebar-logo" alt="JMI Bluesky VUE logo" />
            </div>

            <div className={classes.sideNavWrapper}>
              <div>
                <List component="nav" className={classes.sideNavList}>
                  <ListItemFormHeaders isCancelled={!!cancelledOrder} isHighConfidencePhotos={isHighConfidencePhotos}/>
                </List>
              </div>
              <ExpansionPanel defaultExpanded className={classes.orderInfo}>
                <ExpansionPanelSummary
                  expandIcon={<ExpandLessIcon style={{ color: '#fff' }} />}
                  aria-controls="order-details"
                  id="order-details"
                >
                  <Typography variant="subtitle1" className={classes.orderInfoTitle} noWrap>
                    Order Details
                  </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails style={{ display: 'flex', flexDirection: 'column' }}>
                  <Typography
                    variant="subtitle2"
                    className={classes.toolbarAttribute}
                    noWrap
                    style={{
                      color: '#5e80ae',
                      lineHeight: 'normal',
                      display: 'inline-block',
                      textTransform: 'capitalize',
                      textAlign: 'left',
                      margin: '0 0 ',
                    }}
                  >
                    Report Name
                  </Typography>
                  <span
                    style={{
                      color: '#fff',
                      lineHeight: 'normal',
                      display: 'inline-block',
                      textTransform: 'capitalize',
                      textAlign: 'left',
                      margin: '0 0 0.25rem',
                    }}
                  >
                    {orderInfo.reportName}
                  </span>
                  <OrderInfoFormDefinitions />
                  <Typography
                    variant="subtitle2"
                    className={classes.toolbarAttribute}
                    noWrap
                    style={{
                      color: '#5e80ae',
                      lineHeight: 'normal',
                      display: 'inline-block',
                      textTransform: 'capitalize',
                      textAlign: 'left',
                      margin: '0 0 ',
                    }}
                  >
                    Desktop Used By Field Rep
                  </Typography>
                  <span
                    style={{
                      color: '#fff',
                      lineHeight: 'normal',
                      display: 'inline-block',
                      textTransform: 'capitalize',
                      textAlign: 'left',
                      margin: '0 0 0.25rem',
                    }}
                  >
                    {data.desktopUsedByFr ? 'Yes' : 'No'}
                  </span>
                </ExpansionPanelDetails>
              </ExpansionPanel>
            </div>
          </div>

          <div className="app-main">
            <div className={classnames('app-header')}>
              <div className="row-start-center">
                <ListIcon
                  className={classnames('sidebar-toggle-icon', 'mr-20', !sidebarIsOpen && 'sidebar-toggle-icon-closed')}
                  onClick={() => toggleSidebar(!sidebarIsOpen)}
                />
              </div>
              <Navbar
                className={classes.reviewHeader}
                drawerOpen={drawerOpen}
                setDrawerOpen={setDrawerOpen}
                clientId={clientId}
                returnToGrid={returnToGrid}
                order={orderInfo}
                sideViewForm={sideViewForm}
                setSideViewForm={setSideViewForm}
                setHideAllPhotos={setHideAllPhotos}
                hideAllPhotos={hideAllPhotos}
                isAllPhotosTab={isAllPhotosTab}
                taggedPhotos={taggedPhotos}
                setTaggedPhotos={setTaggedPhotos}
              />
            </div>

            <div className="app-body">
              <div className={classes.contentWrapper}>
                <div
                  style={{
                    maxHeight: cancelledOrder ? '100vh' : 'calc(100vh - 165px)',
                    overflow: 'auto',
                    flex: 1,
                    marginBottom: '0.75rem',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <Content
                    isCancelled={!!cancelledOrder}
                    isCustomerCloseOutForm={isCustomerCloseOutForm}
                    order={orderInfo}
                    setOrder={setOrderInfo}
                    setPdfPreviewLink={setPdfPreviewLink}
                    setIsCompleteDialogOpen={setIsCompleteDialogOpen}
                    setCancelledOrder={setCancelledOrder}
                    setSideViewForm={setSideViewForm}
                    sideViewForm={sideViewForm}
                    setIsAllPhotosTab={setIsAllPhotosTab}
                    hideAllPhotos={hideAllPhotos}
                    taggedPhotos={taggedPhotos}
                    setTaggedPhotos={setTaggedPhotos}
                  />
                </div>
                <ActionBar
                  submitReport={submitReport}
                  submitRCTReport={submitRCTReport}
                  setIsCompleteDialogOpen={setIsCompleteDialogOpen}
                  setIsRCTCompleteDialogOpen={setIsRCTCompleteDialogOpen}
                  setPdfPreviewLink={setPdfPreviewLink}
                  isCancelled={!!cancelledOrder}
                  isRejectRestricted={RejectRestricted}
                  order={orderInfo}
                  setOrder={setOrderInfo}
                  isAllPhotosTab={isAllPhotosTab}
                />
              </div>
            </div>
          </div>

          <Dialog
            open={isCompleteDialogOpen}
            onClose={handleCompleteDialogClose}
            aria-labelledby="complete-order-dialog-title"
            fullWidth
            maxWidth="lg"
            scroll="paper"
            className={classes.pdfDialog}
          >
            <DialogTitle id="complete-order-title">{'Preview Final Report'}</DialogTitle>
            <DialogContent dividers style={{ backgroundColor: 'lightgray' }}>
              <div style={{ margin: '0px auto', padding: '15px 0px' }}>
                <Document
                  file={pdfPreviewLink}
                  noData={'Error: Please regenerate the report.'}
                  onLoadSuccess={onDocumentLoadSuccess}
                >
                  {numPages.map((p, i) => {
                    return (
                      <div key={i} id={'test' + p} style={{ marginBottom: '15px' }}>
                        <Page pageNumber={p} scale={pdfScale} />
                      </div>
                    );
                  })}
                </Document>
              </div>
            </DialogContent>
            <DialogActions style={{ margin: '24px' }}>
              {isReportSubmitting ? (
                <Typography variant="subtitle1" color="primary">
                  {'Submitting Report... '}
                  <CircularProgress color="primary" size={15} />
                </Typography>
              ) : (
                <React.Fragment>
                  <div style={{ flex: 1 }}>
                    <Button onClick={() => setPdfScale(1)} color="primary">
                      Reset Zoom
                    </Button>
                  </div>
                  <div
                    style={{
                      flex: 1,
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'center',
                    }}
                  >
                    <PdfMinus style={{ cursor: 'pointer' }} fontSize="Large" onClick={DecreasePDFScale} />
                    <PdfPlus style={{ cursor: 'pointer' }} fontSize="Large" onClick={IncreasePDFScale} />
                  </div>
                  <div
                    style={{
                      flex: 1,
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'flex-end',
                    }}
                  >
                    <Button onClick={handleCompleteDialogClose} color="primary">
                      Cancel
                    </Button>
                    <Button
                      onClick={submitReport}
                      autoFocus
                      className={classes.completeButton}
                      focusVisibleClassName={classes.completeButtonFocused}
                      //disabled={!cancelledOrder ? true : false}
                    >
                      {'Submit Report'}
                    </Button>
                  </div>
                </React.Fragment>
              )}
            </DialogActions>
          </Dialog>

          <Dialog
            open={isRCTCompleteDialogOpen}
            onClose={handleCompleteDialogClose}
            aria-labelledby="complete-order-dialog-title"
            fullWidth
            maxWidth="lg"
            scroll="paper"
            className={classes.pdfDialog}
          >
            <DialogTitle id="complete-order-title">{'Preview Final Report'}</DialogTitle>
            <DialogContent dividers style={{ backgroundColor: 'lightgray' }}>
              <div style={{ margin: '0px auto', padding: '15px 0px' }}>
                <Document
                  file={pdfPreviewLink}
                  //noData={'Error: Please regenerate the report.'}
                  noData={
                    isStupidICatOrCIGOrder(clientId)
                      ? 'ICat does not require a PDF'
                      : 'Error: Please regenerate the report.'
                  }
                  onLoadSuccess={onDocumentLoadSuccess}
                >
                  {numPages.map((p, i) => {
                    return (
                      <div key={i} id={'test' + p} style={{ marginBottom: '15px' }}>
                        <Page pageNumber={p} scale={pdfScale} />
                      </div>
                    );
                  })}
                </Document>
              </div>
            </DialogContent>
            <DialogActions style={{ margin: '24px' }}>
              {isReportSubmitting ? (
                <Typography variant="subtitle1" color="primary">
                  {'Submitting Report... '}
                  <CircularProgress color="primary" size={15} />
                </Typography>
              ) : (
                <React.Fragment>
                  <div style={{ flex: 1 }}>
                    <Button onClick={() => setPdfScale(1)} color="primary">
                      Reset Zoom
                    </Button>
                  </div>
                  <div
                    style={{
                      flex: 1,
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'center',
                    }}
                  >
                    <PdfMinus style={{ cursor: 'pointer' }} fontSize="Large" onClick={DecreasePDFScale} />
                    <PdfPlus style={{ cursor: 'pointer' }} fontSize="Large" onClick={IncreasePDFScale} />
                  </div>
                  <div
                    style={{
                      flex: 1,
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'flex-end',
                    }}
                  >
                    <Button onClick={handleRCTCompleteDialogClose} color="primary">
                      Cancel
                    </Button>
                    <Button
                      onClick={submitRCTReport}
                      autoFocus
                      className={classes.completeButton}
                      focusVisibleClassName={classes.completeButtonFocused}
                    >
                      {'Submit RCT Report'}
                    </Button>
                  </div>
                </React.Fragment>
              )}
            </DialogActions>
          </Dialog>
        </div>

        <RemoveOrderFormHeaderDialog />
      </OrderReviewProvider>
    )
  );
};

QaOrderReview.propTypes = propTypes;
export default withStyles(styles)(QaOrderReview);
